import { render, staticRenderFns } from "./BuildDomain.vue?vue&type=template&id=10328355&"
import script from "./BuildDomain.vue?vue&type=script&lang=js&"
export * from "./BuildDomain.vue?vue&type=script&lang=js&"
import style0 from "./BuildDomain.vue?vue&type=style&index=0&id=10328355&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports